import { ITheme } from '@ms/yammer-web-core-ui/dist/util/theme';
import { Theme as Fluent9Theme } from '@ms/yammer-web-core-ui/dist/util/theme/fluent9';
import { isInVivaConnectionsApp } from 'vivaConnections';

import { useFluent9TeamsTheme, useFluent9Theme, useIsTeamsHub, useTeamsTheme, useTheme } from './selectors';

type UseAppThemes = () => {
  readonly fluent8: ITheme;
  readonly fluent9: Fluent9Theme;
};

export const useAppThemes: UseAppThemes = () => {
  const defaultTheme = useTheme();
  const fluent9DefaultTheme = useFluent9Theme();
  const teamsTheme = useTeamsTheme();
  const fluent9TeamsTheme = useFluent9TeamsTheme();

  const isInVivaConnections = isInVivaConnectionsApp();
  const isTeamsHub = useIsTeamsHub();

  const [fluent8Theme, fluent9Theme] =
    isTeamsHub || isInVivaConnections ? [teamsTheme, fluent9TeamsTheme] : [defaultTheme, fluent9DefaultTheme];

  return {
    fluent8: fluent8Theme,
    fluent9: fluent9Theme,
  };
};
